'use client';

import AppHeader from '@components/layout/AppHeader/AppHeader';
import { useAppSelector } from '@store/hooks';
import { selectIsUsedCar, selectOrderType } from '@store/selectors';
import { OrderCreationType } from 'next-common';

export const HeaderProvider = ({ children }: { children: React.ReactNode }) => {
  const isUsedCar = useAppSelector(selectIsUsedCar);
  const orderType = useAppSelector(selectOrderType) as OrderCreationType;
  return (
    <div className="bg-white relative min-h-screen w-full">
      <AppHeader isUsedCar={isUsedCar} OrderType={orderType} />
      <div className="min-h-[calc(100vh-8rem)] relative">
        {children}
        <div id="modalPortal"></div>
      </div>
    </div>
  );
};
